<div class="section-footer">
  <div class="icon-action-help">
    <button
      mat-button
      *ngFor="let item of descriptionButton[type].option; let i = index"
      (click)="reset(item.id)"
      id="item.id"
    >
      <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
      <mat-icon
        *ngIf="item.iconSVG"
        class="iconSVG-footer"
        [svgIcon]="item.iconSVG"
      ></mat-icon>
      {{ item.description }}
    </button>
  </div>
  <div class="card-button" *ngIf="!singleOptions">
    <button
      mat-flat-button
      type="submit"
      id="exit"
      class="button-primary-event button-success"
      [disabled]="stateSend || disableButton"
      (click)="sendData()"
      *ngIf="!descriptionButton[type].buttons; else templateButtons"
    >
      {{
        stateAction
          ? descriptionButton?.[type]?.send?.name
          : descriptionButton?.[type]?.update?.name
      }}
    </button>
    <ng-template #templateButtons>
      <button
        mat-flat-button
        *ngFor="let item of descriptionButton[type].buttons; let i = index"
        [id]="item.id"  
        [ngClass]="{
          'button-success': item.type === 'flat'
      }"
        matButton="outlined"
        (click)="!item.items ? buttons(item.id) : buttons(null)"
        [matMenuTriggerFor]="menu"
        [disabled]="item.disabled"
      >
        <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
        <mat-icon
          *ngIf="item.iconSVG"
          class="iconSVG-footer"
          [svgIcon]="item.iconSVG"
        ></mat-icon>
        {{ item.description }}        
      <mat-menu #menu="matMenu">
        <button mat-menu-item *ngFor="let menu of item.menu"
        (click)="buttons(menu.value)">{{menu.text}}</button>
      </mat-menu>
      </button>
    </ng-template>
  </div>
</div>
